<app-spinner></app-spinner>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<div
		class="font-avertareguler w-full h-screen px-2 md:p-4 space-y-4 bg-white/[60%] dark:bg-slate-900/60 relative"
	>
		<div class="flex">
			<h2
				class="text-[#102030] text-[16px] md:text-[20px] font-avertaBold dark:text-white"
			>
				Training Configuration
			</h2>
		</div>
		<div
			class="space-y-4 popBody py-3 scrollbar-thin scrollbar-thumb-[#000733]/20 scrollbar-track-transparent overflow-y-scroll"
		>
			<div class="grid grid-cols-12 items-start">
				<div class="col-span-12 md:col-span-4">
					<span
						class="font-avertaBold block dark:text-white duration-200"
						>Email Configuration:</span
					>
				</div>
				<div class="col-span-12 md:col-span-8">
					<p
						class="text-sm text-[#ba7e1b] bg-[#F5A623]/30 p-2 rounded-2xl"
					>
						<b class="font-avertaBold">Note!</b> Training mail
						configuration are used for setting notifications emails
						to employee based on manual trigger Employee training
						details page.
					</p>
				</div>
			</div>
			<div class="grid grid-cols-12 items-center">
				<div class="col-span-12 md:col-span-4">
					<span
						class="font-avertaBold block dark:text-white duration-200 text-sm"
						>FROM <span class="text-red-600">*</span></span
					>
					<span class="text-xs text-gray-500 hidden md:block"
						>Email Id From</span
					>
				</div>
				<div class="col-span-12 md:col-span-8">
					<div class="w-full">
						<input
							type="text"
							id="from"
							class="block px-2.5 w-full h-[45px] text-sm text-gray-900 bg-white rounded-lg border border-gray-300 appearance-none dark:bg-gray-600 dark:border-gray-500 dark:text-white dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-700 peer"
							placeholder=" "
							formControlName="from"
							[ngClass]="{
								'border-red-600 dark:border-red-500 focus:border-red-600 dark:focus-border-red-500':
									form.get('from')?.invalid &&
									form.get('from')?.touched
							}"
						/>
					</div>
					@if (
						form.get('from')?.hasError('required') &&
						(form.get('from')?.touched || formSubmitted)
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>From is required.</span
							>
						</div>
					}
					@if (
						form.get('from')?.hasError('email') &&
						(form.get('from')?.touched || formSubmitted)
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>Invalid From email.</span
							>
						</div>
					}
				</div>
			</div>
			<div class="grid grid-cols-12 items-center">
				<div class="col-span-12 md:col-span-4">
					<span
						class="font-avertaBold block dark:text-white duration-200 text-sm"
						>SUBJECT <span class="text-red-600">*</span></span
					>
					<span class="text-xs text-gray-500 hidden md:block"
						>Subject</span
					>
				</div>
				<div class="col-span-12 md:col-span-8">
					<div class="w-full">
						<input
							type="text"
							id="subject"
							class="block px-2.5 w-full h-[45px] text-sm text-gray-900 bg-white rounded-lg border border-gray-300 appearance-none dark:bg-gray-600 dark:border-gray-500 dark:text-white dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-700 peer"
							placeholder=" "
							formControlName="subject"
							[ngClass]="{
								'border-red-600 dark:border-red-500 focus:border-red-600 dark:focus-border-red-500':
									form.get('subject')?.invalid &&
									form.get('subject')?.touched
							}"
						/>
					</div>
					@if (
						form.get('subject')?.hasError('required') &&
						(form.get('subject')?.touched || formSubmitted)
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>Subject is required.</span
							>
						</div>
					}
				</div>
			</div>
			<div class="grid grid-cols-12 items-center">
				<div class="col-span-12 md:col-span-4">
					<span
						class="font-avertaBold block dark:text-white duration-200 text-sm"
						>HOST <span class="text-red-600">*</span></span
					>
					<span class="text-xs text-gray-500 hidden md:block"
						>Host Info</span
					>
				</div>
				<div class="col-span-12 md:col-span-8">
					<div class="w-full">
						<input
							type="text"
							id="host"
							class="block px-2.5 w-full h-[45px] text-sm text-gray-900 bg-white rounded-lg border border-gray-300 appearance-none dark:bg-gray-600 dark:border-gray-500 dark:text-white dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-700 peer"
							placeholder=" "
							formControlName="host"
							[ngClass]="{
								'border-red-600 dark:border-red-500 focus:border-red-600 dark:focus-border-red-500':
									form.get('host')?.invalid &&
									form.get('host')?.touched
							}"
						/>
					</div>
					@if (
						form.get('host')?.hasError('required') &&
						(form.get('host')?.touched || formSubmitted)
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>Host is required.</span
							>
						</div>
					}
				</div>
			</div>
			<div class="grid grid-cols-12 items-center">
				<div class="col-span-12 md:col-span-4">
					<span
						class="font-avertaBold block dark:text-white duration-200 text-sm"
						>SMTP PORT <span class="text-red-600">*</span></span
					>
					<span class="text-xs text-gray-500 hidden md:block"
						>SMTP</span
					>
				</div>
				<div class="col-span-12 md:col-span-8">
					<div class="w-full">
						<input
							type="text"
							id="port"
							class="block px-2.5 w-full h-[45px] text-sm text-gray-900 bg-white rounded-lg border border-gray-300 appearance-none dark:bg-gray-600 dark:border-gray-500 dark:text-white dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-700 peer"
							placeholder=" "
							formControlName="port"
							[ngClass]="{
								'border-red-600 dark:border-red-500 focus:border-red-600 dark:focus-border-red-500':
									form.get('port')?.invalid &&
									form.get('port')?.touched
							}"
						/>
					</div>
					@if (
						form.get('port')?.hasError('required') &&
						(form.get('port')?.touched || formSubmitted)
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>SMTP Port is required.</span
							>
						</div>
					}
				</div>
			</div>
			<div class="grid grid-cols-12 items-center">
				<div class="col-span-12 md:col-span-4">
					<span
						class="font-avertaBold block dark:text-white duration-200 text-sm"
						>USER NAME <span class="text-red-600">*</span></span
					>
					<span class="text-xs text-gray-500 hidden md:block"
						>User Name</span
					>
				</div>
				<div class="col-span-12 md:col-span-8">
					<div class="w-full">
						<input
							type="text"
							id="user_name"
							class="block px-2.5 w-full h-[45px] text-sm text-gray-900 bg-white rounded-lg border border-gray-300 appearance-none dark:bg-gray-600 dark:border-gray-500 dark:text-white dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-700 peer"
							placeholder=" "
							formControlName="user_name"
							[ngClass]="{
								'border-red-600 dark:border-red-500 focus:border-red-600 dark:focus-border-red-500':
									form.get('user_name')?.invalid &&
									form.get('user_name')?.touched
							}"
						/>
					</div>
					@if (
						form.get('user_name')?.hasError('required') &&
						(form.get('user_name')?.touched || formSubmitted)
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>User name is required.</span
							>
						</div>
					}
				</div>
			</div>
			<div class="grid grid-cols-12 items-center">
				<div class="col-span-12 md:col-span-4">
					<span
						class="font-avertaBold block dark:text-white duration-200 text-sm"
						>PASSWORD <span class="text-red-600">*</span></span
					>
					<span class="text-xs text-gray-500 hidden md:block"
						>Password</span
					>
				</div>
				<div class="col-span-12 md:col-span-8">
					<div class="w-full">
						<input
							type="text"
							id="password"
							class="block px-2.5 w-full h-[45px] text-sm text-gray-900 bg-white rounded-lg border border-gray-300 appearance-none dark:bg-gray-600 dark:border-gray-500 dark:text-white dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-700 peer"
							placeholder=" "
							formControlName="password"
							[ngClass]="{
								'border-red-600 dark:border-red-500 focus:border-red-600 dark:focus-border-red-500':
									form.get('password')?.invalid &&
									form.get('password')?.touched
							}"
						/>
					</div>
					@if (
						form.get('password')?.hasError('required') &&
						(form.get('password')?.touched || formSubmitted)
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>Password is required.</span
							>
						</div>
					}
				</div>
			</div>
			<div class="grid grid-cols-12 items-center">
				<div class="col-span-12 md:col-span-4">
					<span
						class="font-avertaBold block dark:text-white duration-200 text-sm"
						>Enable SSL <span class="text-red-600">*</span></span
					>
					<span class="text-xs text-gray-500 hidden md:block"
						>SSL check/uncheck</span
					>
				</div>
				<div class="col-span-12 md:col-span-8">
					<label class="inline-flex items-center cursor-pointer">
						<input
							type="checkbox"
							value=""
							class="sr-only peer"
							formControlName="ssl"
						/>
						<div
							class="relative w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
						></div>
						<span style="display: none">ssl</span>
					</label>
				</div>
			</div>
		</div>
		<div class="flex justify-between items-center w-full popFooter">
			<button
				(click)="closeDialog()"
				type="button"
				class="py-2 px-4 space-x-1 rounded-full border border-white text-[16px] bg-[#EEF4FE] text-[#1F74EC] flex items-center dark:bg-white/20 dark:text-white"
			>
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="w-6 h-6"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</span>
				<span>Close</span>
			</button>
			@if (IsTrainingAdmin) {
				<button
					type="submit"
					class="py-2 px-4 space-x-1 rounded-full border border-white text-[16px] bg-[#010D58] text-[#ffffff] flex items-center dark:bg-gray-950"
				>
					<span>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							class="w-6 h-6"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M4.5 12.75l6 6 9-13.5"
							/>
						</svg>
					</span>
					<span>SAVE</span>
				</button>
			}
		</div>
		<button
			(click)="closeDialog()"
			type="button"
			class="absolute right-[5px] mt-2 top-[-2px] h-8 w-8 rounded-full border border-gray-300 flex justify-center items-center bg-gray-100 text-red dark:bg-white/20 dark:text-white"
		>
			<span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-5 h-5"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			</span>
		</button>
	</div>
</form>
